import { setKeyMap } from '@noriginmedia/norigin-spatial-navigation';

import { TTS } from '@/components/Accessibility/speechSynthesizer';

import { Keys, NetworkCallback, System } from '../index';

function registeredKeys() {
  return {
    UP: 38,
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
    OK: 13,
    BACK: 10009,
    SELECT: 195,
  };
}

export const system: System = {
  id: 'xbox',
  init: function () {
    // Custom Key-Mapping for Xbox Enter/Select Key
    setKeyMap({
      up: [38, 203],
      down: [40, 204],
      left: [37, 205],
      right: [39, 206],
      enter: [195, 207],
    });
    setTimeout(() => {
      this.overrideAria = isTTSEnabled();
      if (this.overrideAria) TTS.init();
    }, 500);
  },
  version: () => 'xbox.1.0.0',
  script: () => {
    return <></>;
  },
  keyThrottleDelay: 100,
  key: (keyboardEvent) => {
    const deviceKeys = registeredKeys();
    switch (keyboardEvent.keyCode) {
      case deviceKeys.UP:
      case 203:
        return Keys.UP;
      case deviceKeys.DOWN:
      case 204:
        return Keys.DOWN;
      case deviceKeys.LEFT:
      case 205:
        return Keys.LEFT;
      case deviceKeys.RIGHT:
      case 206:
        return Keys.RIGHT;
      case deviceKeys.OK:
        return Keys.OK;
      case deviceKeys.SELECT:
        return Keys.OK;
      case 27:
      case deviceKeys.BACK:
        return Keys.BACK;
      default:
        return Keys.UNKNOWN;
    }
  },

  getDeviceId: async () => {
    return '';
  },

  getErrorCodePrefix: () => 'F',
  closeApp: () => {
    // Sending a message to the WebView to close the app
    //@ts-ignore
    if (window.chrome?.webview) {
      //@ts-ignore
      window.chrome.webview.postMessage('exit');
    }
  },
  getDeviceAdId: async () => {
    //@ts-ignore
    return window.xbox_msid;
  },
  getAdIdType: async () => {
    return 'msai';
  },
  getIsLimitedAdTracking: async () => {
    //@ts-ignore
    return window.xbox_msid ? false : true;
  },
  monitorConnectionStatus: (callback: NetworkCallback) => {
    const onOffline = () => {
      callback(false);
    };
    const onOnline = () => {
      callback(true);
    };

    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);
    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  },
  hasPointer: false,
  logout: () => {
    //@ts-ignore
    if (window.chrome?.webview) {
      //@ts-ignore
      window.chrome.webview.postMessage('logout');
    }
  },
  overrideAria: false,
};

function isTTSEnabled() {
  try {
    //@ts-ignore
    return typeof window !== 'undefined' && window.xbox_tts === 'True' ? true : false;
  } catch (error) {
    return false;
  }
}
